import { MoonPaySellWidget } from "@moonpay/moonpay-react";
import useProfile from "hooks/useProfile";
import { useSoundPath } from "hooks/useSoundPath";
import { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { createAPI } from "services/api/api";

const PageHeaderAddFunds = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const { user_wallet } = useProfile();
  const api = createAPI();
  const playSound = useSoundPath();

  const config = {
    variant: "overlay",
    quoteCurrencyCode: "usd",
    quoteCurrencyAmount: "100",
    defaultCurrencyCode: "usdc",
    refundWalletAddress: user_wallet,
    visible: isVisible,
    async onInitiateDeposit(properties) {
      const { cryptoCurrencyAmount, depositWalletAddress } = properties;

      try {
        await api
          .post("/me/offramp_usdc", {
            amount: Number(cryptoCurrencyAmount),
            wallet_address: depositWalletAddress,
          })
          .then((response) => console.log(response));
      } catch (error) {
        console.error("Error during deposit initiation:", error);
      }
    },
  };

  useLayoutEffect(() => {
    document.body.removeAttribute("data-moonpay-web-sdk");
    setIsVisible(false);

    const observer = new MutationObserver(() => {
      if (document.body.getAttribute("data-moonpay-web-sdk") === "true") {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });

    const config = { attributes: true };
    observer.observe(document.body, config);

    if (document.body.getAttribute("data-moonpay-web-sdk") === "true") {
      setIsVisible(true);
    }

    return () => {
      observer.disconnect();
    };
  }, [pathname]);

  return (
    <>
      <button
        className="page-header__user-popup-action"
        onClick={() => {
          playSound('main');
          setIsVisible(true);
        }}
      >
        Add Funds
      </button>

      {isVisible && <MoonPaySellWidget {...config} />}
    </>
  );
};

export default PageHeaderAddFunds;
